import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSignalMutationVariables = Types.Exact<{
  input: Types.CreateSignalInput;
}>;

export type CreateSignalMutation = {
  __typename?: 'Mutation';
  createSignal: {
    __typename?: 'Signal';
    id: any;
    name: string;
    signalType: Types.SignalType;
    createdAt: any;
    updatedAt: any;
  };
};

export const CreateSignalDocument = gql`
  mutation CreateSignal($input: CreateSignalInput!) {
    createSignal(input: $input) {
      id
      name
      signalType
      createdAt
      updatedAt
    }
  }
`;
export type CreateSignalMutationFn = Apollo.MutationFunction<
  CreateSignalMutation,
  CreateSignalMutationVariables
>;

/**
 * __useCreateSignalMutation__
 *
 * To run a mutation, you first call `useCreateSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSignalMutation, { data, loading, error }] = useCreateSignalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSignalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSignalMutation,
    CreateSignalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSignalMutation,
    CreateSignalMutationVariables
  >(CreateSignalDocument, options);
}
export type CreateSignalMutationHookResult = ReturnType<
  typeof useCreateSignalMutation
>;
export type CreateSignalMutationResult =
  Apollo.MutationResult<CreateSignalMutation>;
export type CreateSignalMutationOptions = Apollo.BaseMutationOptions<
  CreateSignalMutation,
  CreateSignalMutationVariables
>;
